import React from "react";
import { Button } from "@mantine/core";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface AuditTrailButtonProps {
  /**
   * Organization to open the trail for. Only a SuperAdmin can read an
   * organization other than their own — the backend ignores this for everyone
   * else and scopes the read to the caller's token — so pass it only when
   * viewing another organization. Omitted means "my own org".
   */
  orgId?: string | null;
}

export default function AuditTrailButton({ orgId }: AuditTrailButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      component={Link}
      to={orgId ? `/audit-trail?orgId=${encodeURIComponent(orgId)}` : "/audit-trail"}
      variant="outline"
    >
      {t("TestDashboard.auditTrail", "Audit Trail")}
    </Button>
  );
}
